import type { FC } from 'types/react';

import { Suspense } from 'react';

const SuspenseWrapper: FC = ({ children }) => <Suspense>{children}</Suspense>;

export default SuspenseWrapper;
